import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useRef } from 'react';
import { useLocalizeMessage, ModalWindow, Spinner, } from 'libs.nucleus';
import { StepIndicator } from '../step_indicator';
const noop = () => { };
export const MultiStepsModalWindow = ({ header, hideSubmitButton, isLoading, isSubmitting, onCancel = noop, onShowError, onStepChange, onSubmit = noop, showStepText = false, showSteps = true, stepStates, steps, submitLabel, subtitle, title, }) => {
    const stepContainerRef = useRef(null);
    const translate = useLocalizeMessage();
    const lastStep = steps.length - 1;
    const [currentStep, setCurrentStep] = useState(0);
    const disabled = !stepStates[currentStep]?.isEnabled;
    const goBack = useCallback(() => {
        const step = Math.max(0, currentStep - 1);
        setCurrentStep(step);
        scrollToTop();
        if (onStepChange) {
            onStepChange(step);
        }
    }, [currentStep]);
    const goForward = useCallback(() => {
        const step = Math.min(currentStep + 1, lastStep);
        if (stepStates[step]?.hasError) {
            onShowError?.(step);
            return;
        }
        setCurrentStep(step);
        scrollToTop();
        if (onStepChange) {
            onStepChange(step);
        }
    }, [currentStep, lastStep, stepStates]);
    const scrollToTop = () => {
        if (stepContainerRef.current) {
            if (typeof stepContainerRef.current.scrollTo === 'function') {
                stepContainerRef.current.scrollTo({ top: 0, behavior: 'instant' });
            }
        }
    };
    const backButton = { label: translate('Back'), onClick: goBack };
    const continueButton = {
        label: translate('Continue'),
        onClick: goForward,
        disabled,
    };
    const cancelButton = {
        label: translate('Cancel'),
        onClick: onCancel,
    };
    const doneButton = {
        label: submitLabel ?? translate('Save'),
        onClick: onSubmit,
        content: isSubmitting ? _jsx(Spinner, { size: 'sm' }) : undefined,
        disabled,
    };
    return (_jsxs(ModalWindow, { ...(title ? { title, subtitle } : { header }), isOpen: true, closeWindow: onCancel, footerSecondaryActionButtons: currentStep === 0 ? [cancelButton] : [cancelButton, backButton], footerPrimaryActionButton: currentStep === lastStep ? (hideSubmitButton ? undefined : doneButton) : continueButton, footerCenterContent: showSteps && (_jsx(StepIndicator, { totalSteps: steps.length, currentStep: currentStep + 1, showStepText: showStepText })), width: 'full', modalContentRef: stepContainerRef, children: [isLoading && _jsx(Spinner, { wrapper: 'full' }), steps[currentStep]] }));
};
